module.exports = __webpack_public_path__ + "img/ic-dankortcard.c38473b4.svg";